import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { combineLatest, filter, map, of, switchMap, take } from 'rxjs';
import { AuthService } from '../services/auth/auth.service';
import { FleetApiService } from '../services/api/fleet-api.service';
import { environment } from '../../environments/environment';
import { LoggingService } from '@fleet-monitor/frontend-logging';

// Block onboarding routes for users who already have fleets.
export const onboardingEntryGuard: CanActivateFn = (_route, _state) => {
  const auth = inject(AuthService);
  const api = inject(FleetApiService);
  const logger = inject(LoggingService);

  // E2E bypass keeps existing behavior
  try {
    if (
      !environment.production &&
      typeof window !== 'undefined' &&
      window.localStorage.getItem('E2E_TEST_AUTH') === '1'
    ) {
      return true;
    }
  } catch (error) {
    logger.warn(
      '[onboardingEntryGuard] Unable to read E2E bypass flag',
      error
    );
  }

  return combineLatest([auth.isLoading$, auth.isAuthenticated$]).pipe(
    filter(([loading]) => !loading),
    take(1),
    switchMap(([, isAuthed]) => {
      if (!isAuthed) return of(true);
      return api.getFleets().pipe(
        map(() => {
          // Removing this fleet check to allow access to onboarding even if fleets exist
          // This allows users to create/join additional fleets
          // const hasFleet = (res.fleets || []).length > 0;
          // if (hasFleet) return router.createUrlTree(['/dashboard']);
          return true;
        })
      );
    })
  );
};
